export const ENV = {
  MOCK_DYN: false,
  MOCK_SLG_API: false,
  LOG_LEVEL: import.meta.env.PP_ENV === 'production' ? 'warn' : 'log',
  SOLGARI_HUB: import.meta.env.VITE_SOLGARI_HUB,
  SOLGARI_CALLING_BOT_SERVICE: import.meta.env.VITE_SOLGARI_CALLING_BOT_SERVICE,
  SOLGARI_SIGNALR: import.meta.env.VITE_SIGNALR,
  APP_VERSION: import.meta.env.VITE_VERSION,
  APP_INSIGHTS: import.meta.env.VITE_APP_APPINSIGHTS,
  APP_DEVELOPMENT_MODE: import.meta.env.VITE_APP_DEVELOPMENT_MODE === 'true',
};
